import { State, toDataSourceRequestString } from "@progress/kendo-data-query";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import axios from "axios";
import { PdsrId } from "../PdsrId";
import { pdsrUrls } from "../../../../URL/ApplicationUrls";

export const ContainerOverviewGridQueryKey = "ContainerOverviewGrid";

const fetchData = async (pdsrId: PdsrId, dataState: State) => {
  const baseUrl = pdsrUrls.containersForPdsrWithId(pdsrId);
  const fetchPromise = axios.get(`${baseUrl}?${toDataSourceRequestString(dataState)}`);
  const response = await toast.promise(fetchPromise, {
    error: "Error when fetching",
  });
  return response.data;
};

export default function useContainerOverviewGridQuery({
  pdsrId,
  dataState,
}: {
  readonly pdsrId: PdsrId;
  readonly dataState: State;
}) {
  return useQuery(
    [ContainerOverviewGridQueryKey, toDataSourceRequestString(dataState)],
    () => fetchData(pdsrId, dataState),
    { keepPreviousData: true }
  );
}
